import Component from 'flarum/common/Component';

export default class FillInput extends Component {
  view() {
    const { fillType, value, oninput } = this.attrs;

    let inputType = 'text';
    let inputPattern = undefined;
    let inputTitle = undefined;
    
    if (fillType === 'number') {
      inputType = 'number';
    } else if (fillType === 'zh') {
      inputPattern = "^[\\u4e00-\\u9fa5]+$";
      inputTitle = "请按照原生要求，仅填写纯中文字符";
    } else if (fillType === 'en_lower') {
      inputPattern = "^[a-z ]+$";
      inputTitle = "请遵循标准，仅输入小写字母与空格";
    }

    return (
      <input 
        className="FormControl"
        type={inputType}
        pattern={inputPattern}
        title={inputTitle}
        value={value}
        oninput={(e: any) => {
          let val = e.target.value;
          if (fillType === 'en_lower') {
            val = val.toLowerCase();
          }
          if (oninput) oninput(val);
        }}
      />
    );
  }
}
